import { Filters } from 'types/filters';

export const cleanFilters = (filters: Partial<Filters>): Partial<Filters> => {
  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      // @ts-ignore
      acc[key] = value;
    }
    return acc;
  }, {} as Partial<Filters>);
};

export const hasSignificantFilterChanges = (
  oldFilters: Partial<Filters>,
  newFilters: Partial<Filters>
): boolean => {
  const allKeys = new Set([
    ...Object.keys(oldFilters),
    ...Object.keys(newFilters)
  ]);

  return Array.from(allKeys).some((key) => {
    const field = key as keyof Filters;
    return oldFilters[field] !== newFilters[field];
  });
};
